import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ToolingRoute from "Tooling";
const getRouteObject = store => {
  return {
    path: "tools",
    component: withAsyncRouteLoading(() => {
      return Promise.all([
        import(/* webpackChunkName: "tools" */ "./components"),
      ]).then(([importedModule0]) => {
        const Component = importedModule0.default;
        return Component;
      });
      //.catch(err => {
      // throw err;
      // });
    }),
    childRoutes: [ToolingRoute(store)],
  };
};
export default getRouteObject;
